import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../shared/components/input/FormInput";
import { useTranslation } from "react-i18next";

const CreateClientForm = ({ onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    code: yup.string().required(t("clients.createForm.fields.code.required")),
    name: yup.string().required(t("clients.createForm.fields.name.required")),
  });

  const defaultValues = {
    code: "",
    name: "",
    ga4PropertyId: "",
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormInput
            name="code"
            label={t("clients.createForm.fields.code.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormInput
            name="name"
            label={t("clients.createForm.fields.name.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row">
        <div className="w-full">
          <FormInput
            name="ga4PropertyId"
            label={t("clients.createForm.fields.ga4PropertyId.label")}
          />
        </div>
      </div>
    </BaseForm>
  );
};

export default CreateClientForm;
